<template>
  <v-dialog persistent v-model="enrollTeacherDialog" max-width="65rem">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Teacher Enrollment</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="openCloseSearchPanel()">mdi-magnify</v-icon>
      </v-toolbar>
      <v-container fluid v-if="!deEnrollMode" v-model="panel">
        <v-form ref="form" class="p-2 m-2">
          <v-row>
            <v-col>
              <v-text-field
                v-model="teacherFilter.mobileNo"
                label="Mobile No"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="teacherFilter.email"
                label="Email"
                color="primary"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="teacherFilter.firstName"
                label="First Name"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="teacherFilter.lastName"
                label="Last Name"
                color="primary"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="searchTeachers()">
              Apply
            </v-btn>
          </v-row>
        </v-form>
      </v-container>
      <v-container fluid style="max-height: 22rem; overflow-y: auto">
        <v-data-table
          v-if="teachers.length > 0"
          v-model="selectedTeacher"
          :headers="teacherAssignmentHeaders"
          :items="teachers"
          :hide-default-footer="teachers.length <= 10"
          show-select
          item-key="teacherId"
          item-value="teacherId"
          :single-select="true"
          @contextmenu:row="rightClickHandler"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-row justify="center">
              <v-col>
                <v-chip
                  small
                  :color="
                    item.status == 'ACTIVE' ? 'success-chip' : 'error-chip'
                  "
                >
                  {{ item.status }}
                </v-chip>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.createdOn`]="{ item }">
            {{ formatDateTime(item.createdOn) }}
          </template>
          <template
            v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
          >
            <v-simple-checkbox
              :disabled="item.status != 'ACTIVE'"
              :value="isSelected"
              @input="select($event)"
            ></v-simple-checkbox>
          </template>
        </v-data-table>
        <CustomDataTable
          v-else
          :headers="teacherAssignmentHeaders"
          :items="teachers"
          :hide-default-footer="teachers.length <= 10"
        />
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeEnrollDialog()">Cancel</v-btn>
        <v-btn
          v-if="addClassRoomDialog"
          color="primary"
          text
          @click="selectTeacher()"
          >Assign</v-btn
        >
        <v-btn v-else color="primary" text @click="enrollTeacher()"
          >Assign</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  BASE_URL,
  CLASSROOM_ASSIGN_TEACHER,
  SEARCH_TEACHER,
} from "@/common/apiEndpoints";
import { SET_API_SUCCESS, SET_OVERLAY_VALUE } from "@/store/mutations";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import {
  getAxiosOptions,
  formatDateTime,
  rightClickHandler,
} from "@/common/utility";
import { GET_TOKEN } from "@/store/getters";
import { teacherAssignmentHeaders } from "@/common/tableHeadersData";
import CustomDataTable from "../CustomDataTable.vue";

export default {
  components: {
    CustomDataTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    addClassRoomDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enrollTeacherDialog: false,
      deEnrollMode: false,
      selectedTeacher: [],
      teacherFilter: {},
      teachers: [],
      teacherAssignmentHeaders: teacherAssignmentHeaders,
      panel: [],
      disabledCount: 0,
      editedClassRoom: {
        classRoomId: "",
        teacherId: "",
        teacherName: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
    }),
  },
  methods: {
    ...mapMutations({
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
    }),

    formatDateTime(date) {
      return formatDateTime(date);
    },

    rightClickHandler(e, item) {
      return rightClickHandler(e, item);
    },

    openEnrollTeacherDialog() {
      this.enrollTeacherDialog = true;
      this.panel = [0];
    },

    closeEnrollDialog() {
      this.teacherFilter = {};
      this.selectedTeacher = [];
      this.enrollTeacherDialog = false;
      this.panel = [];
      this.teachers = [];
    },

    selectTeacher() {
      this.editedClassRoom.teacherId = this.selectedTeacher[0].teacherId;
      this.editedClassRoom.teacherName =
        this.selectedTeacher[0].firstName +
        " " +
        this.selectedTeacher[0].lastName;
      this.enrollTeacherDialog = false;
      this.selectedTeacher = [];
      this.$emit("teacher-selected", this.editedClassRoom);
    },

    openEnrollDialog(item) {
      this.enrollTeacherDialog = true;
      this.editedClassRoom.classRoomId = item.classRoomId;
      this.editedClassRoom.teacherId = item.teacherId;
      this.panel = [0];
    },

    searchTeachers() {
      const payload = {};
      let flag = false;
      if (this.teacherFilter.mobileNo) {
        payload.mobileNo = this.teacherFilter.mobileNo.trim();
        flag = true;
      }
      if (this.teacherFilter.email) {
        payload.emailId = this.teacherFilter.email.trim();
        flag = true;
      }
      if (this.teacherFilter.firstName) {
        payload.firstName = this.teacherFilter.firstName.trim();
        flag = true;
      }
      if (this.teacherFilter.lastName) {
        payload.lastName = this.teacherFilter.lastName.trim();
        flag = true;
      }
      let url = SEARCH_TEACHER;
      if (flag) {
        axios
          .post(url, payload, getAxiosOptions(BASE_URL, this.token))
          .then((res) => {
            this.teachers = res.data.teachers;
            const self = this;
            self.disabledCount = 0;
            this.teachers.map((item) => {
              if (item.status != "ACTIVE") {
                self.disabledCount += 1;
              }
            });
            this.panel = [];
          })
          .catch((error) => {
            error = error.errorMessage;
          });
      } else {
        this.panel = [];
      }
    },

    openCloseSearchPanel() {
      this.panel.length == 0 ? (this.panel = [0]) : (this.panel = []);
    },

    enrollTeacher() {
      let payload = {};
      payload.classRoomId = this.editedClassRoom.classRoomId;
      let url = CLASSROOM_ASSIGN_TEACHER;
      payload.teacherId = this.selectedTeacher[0].teacherId;
      this.setOverlayValue(true);
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.closeEnrollDialog();
          this.setOverlayValue(false);
          this.setApiSuccess("Teacher Assigned Successfully");
          this.$emit("teacher-enrolled", res.data);
        })
        .catch((error) => {
          error = error.errorMessage;
          this.closeEnrollDialog();
          this.setOverlayValue(false);
        });
    },
  },
};
</script>